
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["w-6 h-6",classNames,staticClass],
              style: [{"padding":"1px"},style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"97.999px","height":"83.39px","viewBox":"0 0 97.999 83.39","enable-background":"new 0 0 97.999 83.39","xml:space":"preserve","style":"padding:1px"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M78.294,83.39H19.713c-5.087-0.095-9.309-3.611-10.359-8.544L0.346,36.253c-0.817-3.121-0.174-6.522,1.79-9.214\n\tc1.984-2.724,5.044-4.353,8.393-4.468h4.649L32.803,1.646c1.643-1.952,4.559-2.205,6.511-0.557c1.952,1.643,2.203,4.559,0.557,6.511\n\tL27.265,22.57l43.483-0.002L58.141,7.599c-1.647-1.952-1.395-4.868,0.555-6.513c1.954-1.647,4.875-1.39,6.513,0.56L82.83,22.568\n\th4.495c3.502,0.117,6.563,1.747,8.549,4.471c1.963,2.69,2.604,6.089,1.765,9.325l-9.004,38.572\n\tc-1.025,4.843-5.249,8.359-10.25,8.454C78.353,83.39,78.326,83.39,78.294,83.39z M80.623,31.809l-69.937,0.002\n\tc-0.329,0.014-0.781,0.26-1.079,0.67c-0.32,0.44-0.429,1.02-0.289,1.553l9.056,38.798c0.172,0.799,0.749,1.3,1.426,1.313h58.434\n\tc0.668-0.027,1.232-0.524,1.377-1.219l9.054-38.778c0.167-0.648,0.059-1.228-0.257-1.663c-0.302-0.413-0.754-0.661-1.241-0.677\n\th-6.432C80.696,31.805,80.655,31.807,80.623,31.809z"}})])
          )
        }
      }
    